<template>
  <div class="yzxbuy-entrance">
   <top-title></top-title>
   <price :priceList="priceList" class=""></price>
   <brightPoints></brightPoints>
   <comparison></comparison>
   <trial></trial>
  </div>
</template>
<script>
import topTitle from './components/topTitle.vue';
import price from './components/price.vue';
import brightPoints from './components/brightPoints.vue';
import comparison from './components/comparison.vue';
import trial from '@/views/productFeatures/components/trial';

import {getBuyInfoCommon} from "@/api/yzxBuyEntrance.js";

export default {
  name: 'yzxBuyEntrance',
  components: {topTitle,price,brightPoints,comparison,trial},
  data(){
    return{
      priceList:[]
    }
  },
  created() {
    this.getBuyInfo();
  },
  methods: {
    getBuyInfo() {
      getBuyInfoCommon().then((res)=>{
        if (res.success) {
          this.priceList = res.data;
        }

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.yzxbuy-entrance {
  width: 100%;
  .yzx-price{
    // margin-top: -10px;
  }
}
@media (min-width: 750px) and (max-width: 960px) {
  // .yzxbuy-entrance {
  // }
}
@media (min-width: 961px) {
  // .yzxbuy-entrance {
  // }
}